import { request } from '../lib/http'

/**
 * @returns {Promise<Array>}
 */
export function fetchAll () {
  return request({
    url: 'user',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `user`,
    method: 'get',
    params: queriesParams
  })
}

/**
 * @returns {Promise<Object>}
 */
export function authUser () {
  return request({
    url: 'auth-user',
    method: 'get'
  })
}

/**
 * @param {Object} user
 * @param {Number} user.company
 * @param {String} user.name
 * @param {String} user.email
 * @param {Array<Number>} user.groups
 * @returns {Promise<Object>} Promise com o usuario criado.
 */
export function addUser (user) {
  return request({
    method: 'post',
    url: 'user',
    data: user
  })
}

/**
 * @param {Number} id
 * @returns {Promise<Object>}
 */
export function show (id) {
  return request({
    url: `user/${id}`,
    method: 'get'
  })
}

/**
 * @param {Number} id
 * @param {Number} data.company
 * @param {String} data.name
 * @param {String} data.email
 * @param {Array<Number>} data.groups
 * @returns {Promise<Object>}
 */
export function edit (id, data) {
  return request({
    url: `user/${id}`,
    method: 'patch',
    data
  })
}

export function fetchPartners () {
  return request({
    url: `user-garage-accredited`,
    method: 'get'
  })
}
